import {gql} from '@apollo/client'

export const CREATE_COMMISSION_REPORT_LOG = gql`
  mutation createCommissionReportLog($input: commission_report_log_input!) {
    commissionReportLogCreateMutation(input: $input) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_COMMISSION_REPORT_LOG = gql`
  mutation updateCommissionReportLog($id: ID!, $input: commission_report_log_input!) {
    commissionReportLogUpdateMutation(id: $id, input: $input) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_COMMISSION_REPORT_LOG = gql`
  mutation deleteCommissionReportLog($id: ID!) {
    commissionReportLogDeleteMutation(id: $id) {
      success
      errors {
        message
      }
    }
  }
`